import { environment } from 'src/environments/environment';
import { Servicio } from './../models/Servicio/Servicio';
import { HttpClient } from "@angular/common/http";
import { PagedResponse } from '../shared/models/PagedResponse';
import { Observable } from 'rxjs';
import { ServicioFilter } from '../models/Servicio/ServicioFilter';
import { Page } from '../shared/models/Page';
import { Injectable } from '@angular/core';
import { Response } from '../shared/models/Response';
@Injectable({
    providedIn: "root",
})
export class ServicioService {
   private REST_API_SERVER = environment.backend_server + "/servicio";

   constructor(private http: HttpClient) {}
    getDataByPage(filtro: ServicioFilter, page: Page): Observable<PagedResponse<Servicio>> {
        let stringNombre = filtro.nombre && filtro.nombre != "" ? filtro.nombre : null;
        let nombre = filtro.nombre ? filtro.nombre : "";
        let emisorId = filtro.emisorId ? filtro.emisorId : "";
        let activo = filtro.activo != null ? (filtro.activo ? 0 : 1) : 1;
        let exento = filtro.exento != null ? (filtro.exento ? 1 : 0) : "";
        let sucursal = filtro.sucursalId != null ? filtro.sucursalId : "";
        return this.http.get<PagedResponse<Servicio>>(this.REST_API_SERVER + "/list/filter" + "?nombre=" + nombre + "&activo=" + activo + "&exento=" + exento + "&EmisorId=" + emisorId + "&SucursalId=" + sucursal + "&pageNumber=" + page.pageNumber + "&pageSize=" + page.pageSize);
    }
    sendServiceRequest(service: Servicio): Observable<Response<Servicio>> {
        delete service.servicioId;
        return this.http.post<Response<Servicio>>(this.REST_API_SERVER + "/add", service);
    }
    editServiceRequest(service: Servicio): Observable<Response<boolean>> {
        return this.http.post<Response<boolean>>(
            `${this.REST_API_SERVER}/update`,
            service
        );
    }
    toggle(serviceId: string, action: boolean): Observable<Response<boolean>> {
        return this.http.get<Response<boolean>>(
            `${this.REST_API_SERVER}/toggle/${serviceId}/${action}`
        );
    }
}